export default __webpack_public_path__ + "static/media/get-logo.a255e794.png";